if (typeof Symbol === "function" && !Symbol.asyncIterator) {
    Symbol.asyncIterator = Symbol.for("Symbol.asyncIterator");
}

//# sourceMappingURL=asyncIterable.js.map



// WEBPACK FOOTER //
// ./node_modules/prex-es5/out/lib/asyncIterable.js